/*************************************************************************
* Copyright (c) 2025 Omnineura AI Technologies Pvt Limited.
* All rights reserved.
* This code is licensed under the 'Omnineura AI License' found in the LICENSE file.
* Unauthorized copying, sharing, or use of this code is prohibited.
* The intellectual and technical concepts are proprietary to Omnineura AI Technologies Pvt Limited.
* Author: surya@Omnineura.ai
* Date: 11-09-2025
*************************************************************************/

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRagconfigApi, saveRagconfigApi } from "../services/api";



// Fetch configuration
export const fetchConfiguration = createAsyncThunk(
  "config/fetchConfiguration",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getRagconfigApi();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch config");
    }
  }
);

// Save configuration
export const saveConfiguration = createAsyncThunk(
  "config/saveConfiguration",
  async (updatedConfig, { rejectWithValue }) => {
    try {
      // const token = getState().auth.token;
      const response = await saveRagconfigApi(updatedConfig)
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to save config");
    }
  }
);

const ragConfigReducer = createSlice({
  name: "config",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearConfig: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch
      .addCase(fetchConfiguration.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchConfiguration.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.rag_config;
      })
      .addCase(fetchConfiguration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // save
      .addCase(saveConfiguration.fulfilled, (state, action) => {
        state.data = action.payload; // update local store with saved config
      });
  },
});

export const { clearConfig } = ragConfigReducer.actions;
export default ragConfigReducer.reducer;
